import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="module-storage-types" id="module-storage-types"></a>
    <h1 {...{
      "id": "requireuxpstoragetypes"
    }}>{`require('uxp').storage.types`}</h1>
    <a name="new-module-storage-types-new" id="new-module-storage-types-new"></a>
    <h2 {...{
      "id": "types"
    }}>{`types()`}</h2>
    <p>{`This namespace describes the type of the entry. Whether file or folder etc.`}</p>
    <a name="module-storage-types-file" id="module-storage-types-file"></a>
    <h2 {...{
      "id": "file--symbol"
    }}>{`file : `}<inlineCode parentName="h2">{`Symbol`}</inlineCode></h2>
    <p>{`A file; used when creating an entity`}</p>
    <a name="module-storage-types-folder" id="module-storage-types-folder"></a>
    <h2 {...{
      "id": "folder--symbol"
    }}>{`folder : `}<inlineCode parentName="h2">{`Symbol`}</inlineCode></h2>
    <p>{`A folder; used when creating an entity`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      